module.exports = __webpack_public_path__ + "static/media/TitlingGothicFBNormal-Bold.6ca37750.woff";